import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { take, switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { SessionService } from 'src/app/store/session/session.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard  {
  constructor(protected router: Router, protected sessionService: SessionService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.validate(route, state);
  }

  private validate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.sessionService.getUser().pipe(
      take(1),
      switchMap(user => {
        const { roles, permissions } = route.data;
        const hasRole = user?.hasRoles(...roles);
        let hasPermission = false;
        if (permissions?.length) {
          hasPermission = user?.hasAnyPermission(...permissions) ?? false;
        }

        if (user?.hasRole('DEALER') && user?.status === 'WAITING') {
          this.router.navigateByUrl('/dealer-unauthorized');
          return of(false);
        } else if (user?.hasRole('DEALER') && user?.status === 'DENIED') {
          this.router.navigateByUrl('dealer-denied');
          return of(false);
        }


        if (hasRole) {
          return of(true);
        }


        if (hasPermission) {
          return of(true);
        }

        const isAvaliador = user?.hasRoleAvaliador();
        if (isAvaliador) {
          this.router.navigate(['/captar/veiculos']);
          return of(false);
        }

        const isArremate = user?.hasRoleArremate();
        if (isArremate) {
          this.router.navigate(['/arrematar/veiculos']);
          return of(false);
        }

        const isOemDealer = user?.hasPermissionMenuVender();
        if (isOemDealer) {
          const sellHome = user.getDefaultSellRoute() ?? '/vender/veiculos';
          const currentUrl = state.url.split('?')[0];
          const sellHomePath = sellHome.split('?')[0];
          if (currentUrl !== sellHomePath && !currentUrl.startsWith(`${sellHomePath}/`)) {
            this.router.navigateByUrl(sellHome);
            return of(false);
          }
        }

        const platformAdminHome = user?.getDefaultPlatformAdminRoute();
        if (platformAdminHome) {
          const currentUrl = state.url.split('?')[0];
          const adminHomePath = platformAdminHome.split('?')[0];
          if (currentUrl !== adminHomePath && !currentUrl.startsWith(`${adminHomePath}/`)) {
            this.router.navigateByUrl(platformAdminHome);
            return of(false);
          }
        }

        const oemDealerAdminHome = user?.getDefaultOemDealerAdminRoute();
        if (oemDealerAdminHome) {
          const currentUrl = state.url.split('?')[0];
          const oemAdminHomePath = oemDealerAdminHome.split('?')[0];
          if (currentUrl !== oemAdminHomePath && !currentUrl.startsWith(`${oemAdminHomePath}/`)) {
            this.router.navigateByUrl(oemDealerAdminHome);
            return of(false);
          }
        }

        if (!user) {
          const returnUrl = state.url;
          this.router.navigate(['/login'], { queryParams: { returnUrl } });
        } else {
          this.router.navigate(['/logout']);
        }
        return of(false);
      })
    );
  }
}
